import React from 'react';
import { Alert, Form, Button, } from 'react-bootstrap';
import { ClipboardButton, Toast, } from '@payit/cool-web-ui-library';
import CryptoService from '../../service/CryptoService';
import HtmlUtils from '../../modules/HtmlUtils';

class EncryptDecrypt extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.encrypt = this.encrypt.bind(this);
    this.decrypt = this.decrypt.bind(this);
    this.encryptAgain = this.encryptAgain.bind(this);
    this.decryptAgain = this.decryptAgain.bind(this);

    this.state = {
      input: '',
      output: '',
      submitted: false,
      status: '',
      visibilityEncrypt: 'hidden',
      visibilityDecrypt: 'hidden',
    };
  }

  handleChange(e) {
    this.setState({ input: e.target.value, });
  }

  handleDismiss() {
    this.setState({ status: '', });
  }

  encrypt(e) {
    e.preventDefault();
    const { input, } = this.state;
    const text = { text: input, };

    CryptoService.encrypt(text)
      .then((response) => {
        this.setState({
          output: response.data, submitted: true, visibilityEncrypt: 'shown', visibilityDecrypt: 'hidden',
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  decrypt(e) {
    e.preventDefault();
    const { input, } = this.state;
    const text = { text: input, };

    CryptoService.decrypt(text)
      .then((response) => {
        this.setState({
          output: response.data, submitted: true, visibilityDecrypt: 'shown', visibilityEncrypt: 'hidden',
        });
      })
      .catch((err) => {
        this.setState({
          status: (
            <Alert variant="danger" onClose={this.handleDismiss} dismissible>
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
            </Alert>
          ),
          submitted: false,
        });

        console.error(err);
      });
  }

  encryptAgain(e) {
    e.preventDefault();
    const { output, } = this.state;
    const text = { text: output, };

    CryptoService.encrypt(text)
      .then((response) => {
        this.setState({
          output: response.data, submitted: true,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  decryptAgain(e) {
    e.preventDefault();
    const { output, } = this.state;
    const text = { text: output, };

    CryptoService.decrypt(text)
      .then((response) => {
        this.setState({ output: response.data, submitted: true, });
      })
      .catch((err) => {
        this.setState({
          status: (
            <Alert variant="danger" onClose={this.handleDismiss} dismissible>
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
            </Alert>
          ),
          submitted: false,
        });

        console.error(err);
      });
  }

  render() {
    const {
      input, output, submitted, status, visibilityEncrypt, visibilityDecrypt,
    } = this.state;
    return (
      <div className="container">
        <Form className="p-5">
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Enter text to be encrypted/decrypted"
              value={input}
              onChange={this.handleChange}
            />
          </Form.Group>
          <Button className="me-2" variant="primary" type="submit" onClick={this.encrypt}>
            Encrypt
          </Button>
          <Button className="me-2" variant="primary" type="submit" onClick={this.decrypt}>
            Decrypt
          </Button>
          <Button className={`me-2 ${visibilityEncrypt}`} variant="primary" type="submit" onClick={this.encryptAgain}>
            Encrypt Again
          </Button>
          <Button className={visibilityDecrypt} variant="primary" type="submit" onClick={this.decryptAgain}>
            Decrypt Again
          </Button>
        </Form>
        {!submitted ? null : (
          <div className="p-5 mb-3">
            <span>Copy output to clipboard: </span>
            <ClipboardButton stringToCopy={HtmlUtils.toHtmlText(output)} />
            <pre style={{
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              marginBottom: 0,
              marginTop: '1rem',
            }}
            >
              {HtmlUtils.toHtmlText(output)}
            </pre>
            <Toast />
          </div>
        )}
        {status}
      </div>
    );
  }
}

export default EncryptDecrypt;
